<script>
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import { field } from "svelte-forms";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import client from "../../../services/client";
	import { navigate } from "svelte-routing";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { errorMessage, loading } from "../../../store/store";
	import Loader from "../../../components/Loader/Loader.svelte";
	import { extractErrorMessage } from "src/utils/misc";

	// No validation on this form (sveltik had none); a plain field store backs
	// the input value.
	const name = field("name", "");

	async function handleSubmit() {
		try {
			errorMessage.set("");
			const res = await client("/v0/Group/Create", {
				method: "POST",
				version: "Tasking",
				data: {
					name: $name.value,
				},
			});
			if (res.status === 200) {
				navigate("/master-data/group");
			}
		} catch (err) {
			extractErrorMessage(err);
		}
	}

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
	let load;
	loading.subscribe((value) => {
		load = value;
	});
</script>

<form on:submit|preventDefault={handleSubmit}>
	<Row>
		<Col>
			<ErrorMessageHandler message={err} />
			<div>
				<PageHeader title="Create Group" />
				<Col>
					<Row>
						<Col>
							<label for="groupName" class="d-flex pt-3">
								<span> Name* </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={4}>
							<input
								type="text"
								id="groupName"
								class="form-control getgo input"
								name="name"
								bind:value={$name.value}
							/>
						</Col>
					</Row>
				</Col>
				<Col class="d-flex justify-content-start pt-2 col-6">
					<Row>
						<Col>
							<Button
								class="themeButton primary "
								disabled={load}
							>
								{#if load}
									<Loader />
								{:else}
									Create
								{/if}
							</Button>
						</Col>
					</Row>
				</Col>
			</div></Col
		>
	</Row>
</form>
